import { Col, Row } from '@design-system/components/grid/grid';
import { ExtrasEmptyState } from './components/ExtrasEmptyState';
import { ExtrasHeader } from './components/ExtrasHeader';
import { ExtrasContent } from './components/ExtrasContent';
import { ExtrasForms } from './ExtrasForm.view';

export const ExtrasView = () => {
  return (
    <Row>
      <Col gap="3xl" className="w-full">
        <ExtrasHeader />
        <ExtrasEmptyState />
        <ExtrasContent />
        <ExtrasForms />
      </Col>
    </Row>
  );
};
